import { SSpace, SName, SectionHeader } from './TitledAlarmTypeGroup.styles';
import type { AlarmsAccountTitle } from '../../containers/Alarm/Alarm';
import AlarmType from './AlarmType';

type TitledAlarmTypeGroupProps = {
  titledAlarmsGroup: AlarmsAccountTitle;
  currentLang: string;
};

export function TitledAlarmTypeGroup(props: TitledAlarmTypeGroupProps) {
  const { titledAlarmsGroup, currentLang } = props;

  return (
    <div>
      <SectionHeader>
        <SName>{titledAlarmsGroup.name}</SName>
      </SectionHeader>
      {titledAlarmsGroup.alarms.map((item, key) => (
        <AlarmType
          key={`${titledAlarmsGroup.name}-${key}`}
          alarmTypeItem={item}
          currentLang={currentLang}
        />
      ))}
      <SSpace />
    </div>
  );
}
